import { useFirebase } from "@popped/popshap-kiosk-components";
import React, { FC } from "react";

const DataContext =
  React.createContext<
    | {
      config: any;
    }
    | undefined
  >(undefined);

export const DataProvider: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const firebase = useFirebase();
  const [config, setConfig] = React.useState<any>(undefined);

  React.useEffect(() => {
    if (firebase) {
      const unsub1 = firebase!.getItem("", (project) => {
        setConfig(project);
        console.log(project)

      });
      return () => {
        unsub1();
      };
    }
  }, [firebase]);

  return (
    <DataContext.Provider
      value={{
        config
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => React.useContext(DataContext);
